import { ElNotification } from "element-plus";
import GlobalConf from "@2kog/pkg-common/data/global.json";
import RxTime from "@2kog/pkg-common/utils/rx-time";
import { getCdnLink } from "@2kog/pkg-common/utils/common.js";
// 后台时间固定为东八区
const timeInstance = new RxTime("Asia/Shanghai");
/**
 * 头像地址
 * @param {*} url
 */
export function avatarUrl(url) {
    if (url) {
        if (url.startsWith("http")) {
            return url;
        }
        return GlobalConf.__cdn + "/" + url;
    }
    return require("../assets/img/common/avatar.svg");
}

/**
 * 去除对象空值
 * @param {*} obj
 * @returns
 */
export function removeEmpty(obj) {
    const newObj = {};
    for (const key in obj) {
        if (obj[key] !== null && obj[key] !== undefined && obj[key] !== "") {
            newObj[key] = obj[key];
        }
    }
    return newObj;
}

/**
 * 复制文本
 */
export function copyText(text) {
    if (navigator.clipboard) {
        navigator.clipboard.writeText(text);
        ElNotification({
            title: "复制成功",
            message: text,
            type: "success",
        });
    } else {
        const input = document.createElement("input");
        input.value = text;
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
        ElNotification({
            title: "复制成功",
            message: text,
            type: "success",
        });
    }
}

// params 不确定的对象
export function removeEmptyParams(params) {
    const newParams = {};
    for (const key in params) {
        if (params[key] !== undefined && params[key] !== "") {
            newParams[key] = params[key];
        }
    }
    return newParams;
}

// 时间转换
export function formatTime(time, format = "YYYY-MM-DD HH:mm:ss") {
    if (!time) return "-";
    const _time = new Date(time);
    if (Number.isNaN(_time.getTime())) return "-";
    return timeInstance.format(_time, format);
}

// 数组转tree
export function array2Tree(array, params = { parentKey: "parent_id", parentValue: 0, childrenKey: "children" }) {
    const tree = [];
    // 在数组中查找具有指定父ID的所有子项
    for (let i = 0; i < array.length; i++) {
        if (~~array[i][params.parentKey] === ~~params.parentValue) {
            // 递归调用，将子项转换为子树
            const children = array2Tree(array, { ...params, parentValue: array[i].id });

            if (children.length) {
                array[i][params.childrenKey] = children;
            }

            tree.push(array[i]);
        }
    }

    return tree;
}

// 多字段排序
export function sortBy(filed1, filed2) {
    return function (a, b) {
        if (a[filed1] === b[filed1]) {
            return a[filed2].localeCompare(b[filed2]);
        }
        return a[filed1].localeCompare(b[filed1]);
    };
}

// 导出csv
export function exportCsv(list, titles = []) {
    if (!titles.length) return list;
    const keys = titles.map((item) => item.key);
    const labels = titles.map((item) => item.label);
    const mapList = [];
    list.forEach((item) => {
        const newItem = [];
        keys.forEach((key) => {
            newItem.push(item[key]);
        });
        mapList.push(newItem.join(","));
    });
    mapList.unshift(labels.join(","));
    return mapList.join("\r\n");
}

// 导出xlsx
export function exportXlsx(list, titles = []) {
    if (!titles.length) return list;
    const keys = titles.map((item) => item.key);
    const labels = titles.map((item) => item.label);
    const mapList = [];
    list.forEach((item) => {
        const newItem = [];
        keys.forEach((key) => {
            newItem.push(item[key]);
        });
        mapList.push(newItem);
    });
    mapList.unshift(labels);
    return mapList;
}

// 是否只保留remainKey
export function arr2map({ array = [], key = "key", remainKey = "" } = {}) {
    if (
        !array?.length ||
        !array.every((item) => key in item) ||
        (remainKey && !array.every((item) => remainKey in item))
    ) {
        console.log("【参数错误】", array, key, remainKey);
        return {};
    }
    return array.reduce((acc, cur) => {
        return { ...acc, [cur[key]]: remainKey ? cur[remainKey] : cur };
    }, {});
}

export function map2arr(map) {
    return Object.entries(map).map(([key, value]) => {
        return {
            name: value,
            key: key,
        };
    });
}

// 去除富文本内容中的base64图片  Tinymce
export function removeBase64Img(content) {
    // img左右可能是转义符 &lt;img&gt; 或者 <img>
    return content.replace(/(&lt;|<)img[^>]*?src="data:image[^>]*?(&gt;|>)/gi, "");
}

// 格式化文件大小
export function formatFileSize(size) {
    if (!size) return "0";
    if (size < 1024) {
        return size + "B";
    } else if (size < 1024 * 1024) {
        return (size / 1024).toFixed(2) + "KB";
    } else {
        return (size / 1024 / 1024).toFixed(2) + "MB";
    }
}

export function formatNumber(num, fixed = 0, prefix = "") {
    if (!num || isNaN(num)) return `${prefix}0`;

    // 将数字转换为字符串，保留两位小数
    const formattedNumber = num.toFixed(fixed).replace(/\B(?=(\d{3})+(?!\d))/g, ","); // 每三位添加一个逗号

    return `${prefix}${formattedNumber}`;
}

// 按字节长度截取字符串
export function sliceByBytes(str, maxBytes) {
    let bytes = 0; // 已使用的字节数
    let result = ""; // 最终提取的字符串

    for (const char of str) {
        const charCode = char.charCodeAt(0);

        // 判断字符所占字节数
        if (charCode <= 0x7f) {
            bytes += 1; // ASCII字符占1字节
        } else if (charCode <= 0x7ff) {
            bytes += 2; // 双字节字符
        } else if (charCode <= 0xffff) {
            bytes += 3; // 常见中文字符占3字节
        } else {
            bytes += 4; // 其他特殊字符占4字节
        }

        // 如果超出最大字节数，停止提取
        if (bytes > maxBytes) {
            break;
        }

        result += char;
    }

    return result;
}
// 为空时不会处理
// 默认使用88*88方形，可返回方形(传递单数字)或者指定任意居中剪裁尺寸(传递数组)或指定任意预设样式(传递字符串)
export function getThumbnail(url, size = 88, replace = true) {
    if (!url) return "";

    if (replace) {
        url = getCdnLink(url);
    }

    const pathname = url.split(/[?#]/)[0];
    if (/\.svg$/i.test(pathname)) {
        return url;
    }

    if (Array.isArray(size)) {
        url += `?x-oss-process=image/auto-orient,1/resize,m_fill,w_${size[0]},h_${size[1]}/quality,Q_100`;
    } else if (isNaN(size)) {
        url += `?x-oss-process=style/${size}`;
    } else {
        url += `?x-oss-process=image/auto-orient,1/resize,m_fill,w_${size},h_${size}/quality,Q_100`;
    }

    return url;
}

export function parseQueryString(query) {
    return query
        ? query.split("&").reduce((acc, pair) => {
              const [key, value] = pair.split("=");
              acc[decodeURIComponent(key)] = decodeURIComponent(value || "");
              return acc;
          }, {})
        : {};
}

export function encodeQueryString(params) {
    return params
        ? "?" +
              Object.keys(params)
                  .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
                  .join("&")
        : "";
}
